import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { Box, Typography } from "@mui/material";
import classes from './VariationTipCard.module.scss';
import { VariationTipCardProps } from "../../interfaces/props/VariationTipCardProps";

const NUMBER_OF_CHARACHTERS = 350;
const ContentFeedImage = (
  <Box
    component={'img'}
    className='image-variations-placeholder'
  />
);

const VariationTipCard = ({ variation, showUser = true }: VariationTipCardProps) => {
  const analysisSnippet = variation.attributes.analysis
    ? `${variation.attributes.analysis.substring(0, NUMBER_OF_CHARACHTERS)}${variation.attributes.analysis.length > NUMBER_OF_CHARACHTERS ? '...' : ''}`
    : 'No analysis available';

  return (
    <Link to={`../tip-variation/${variation.id}`}
      style={{ textDecoration: 'none', color: 'black' }}
      className="d-flex flex-column flex-md-row mb-3 border rounded overflow-hidden shadow-sm">
      <Box className="d-flex align-items-center justify-content-center bg-light flex-shrink-0"
      >
        {ContentFeedImage}
      </Box>
      <Box className="d-flex flex-column justify-content-between p-3 flex-grow-1 overflow-hidden">
        <Box className="mb-2">
          <Box className="d-flex justify-content-between align-items-start mb-1 mb-sm-2">
            <Typography
              className='text-truncate text-headline'
            >
              {variation.attributes.title}
            </Typography>
            <Typography
              variant="caption"
              className="text-secondary flex-shrink-0"
            >
              {dayjs(variation.attributes.createdAt).format('DD.MM.YYYY')}
            </Typography>
          </Box>
          <Typography
            variant="body2"
            color="text.secondary"
            className={`${classes.analysisSnippet} my-2 my-sm-3`}
          >
            {analysisSnippet}
          </Typography>
        </Box>
        <Box className={`d-flex flex-wrap justify-content-between align-items-center`}>
          {showUser && <Typography variant="caption" color="text.secondary" className="mb-1 mb-sm-0">
            By: {variation.attributes.user?.data?.attributes?.username ?? 'Unknown User'}
          </Typography>}
          <Typography variant="caption" color="text.secondary" className="py-1">
            Type: {variation.attributes.type ?? 'Unknown Type'}
          </Typography>
          <Typography variant="caption" color="text.secondary" className="py-1">
            Language: {variation.attributes.language?.data?.attributes?.name ?? 'Unknown Language'}
          </Typography>
        </Box>
      </Box>
    </Link>
  );
};

export default VariationTipCard;
